<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">Ações</h6>
    </d-card-header>

    <d-card-body class="px-0" v-if="model.id">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button class="btn-danger btn-block" @click="confirmDeleteRow()">
            <template>
              <i class="fas fa-trash mr-1"></i>
              <span class="d-inline">Excluir Distribuidor</span>
            </template>
          </d-button>
          <d-button
            :class="
              [model.status == 0 ? 'btn-info' : 'btn-secondary'] + ' btn-block'
            "
            @click="blockAccess()"
          >
            <template v-if="model.status == 1">
              <i class="fas fa-ban mr-1"></i>
              <span class="d-inline">Desativar Distribuidor</span>
            </template>
            <template v-else>
              <i class="fas fa-check-circle mr-1"></i>
              <span class="d-inline">Ativar Distribuidor</span>
            </template>
          </d-button>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>
    <d-card-footer :class="model.id ? 'border-top' : ''">
      <d-button class="btn-dark btn-block" @click="goBack">Voltar</d-button>
      <d-button class="btn-primary btn-block" @click="save()">Salvar</d-button>
    </d-card-footer>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { MODEL, _DELETE_DISTRIBUTOR_ } from './DistributorModel';

export default {
  name: 'sidebar-actions',
  props: {
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  methods: {
    ...mapActions(['setToggle']),
    blockAccess() {
      this.$emit('blockAccess', this.model);
      this.model.status = this.model.status === 1 ? 0 : 1;
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_DISTRIBUTOR_, this.model);
    },
    goBack() {
      this.$router.go(-1);
    },
    save() {
      this.$emit('save', this.model);
    },
  },
};
</script>
<style lang="scss" scoped>
i.material-icons {
  top: 5px;
}
</style>
